import React from 'react';
import { CalculatorIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
const CALCULATORS = ['Nutrition Calculator', 'Hydration Calculator', 'Training Load Calculator'];
export function Testimonials() {
  return <section className="px-5 py-8" data-id="element-201" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-xl overflow-hidden rounded-3xl border border-[var(--pb-lime)]/45 bg-[#101b2d]/98 p-6 text-center shadow-2xl shadow-black/40" data-id="element-202" data-mp="3fxb4en3udyea">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-[var(--pb-lime)] text-[var(--pb-navy)]" data-id="element-203" data-mp="36zr35e5zc23o">
          <GiftIcon size={25} aria-hidden data-id="element-204" data-mp="32290g5ik2j44" />
        </div>
        <p className="mt-4 text-xs font-800 uppercase tracking-[0.18em] text-[var(--pb-lime)]" data-id="element-205" data-mp="2x1utkqsoxf7o">
          Included at No Extra Cost
        </p>
        <h2 className="mt-2 font-display text-3xl font-800 uppercase leading-[0.95] text-white sm:text-4xl" data-id="element-206" data-mp="2s431nws1pt3h">
          Claim This Extra Bonus,
          <span className="block text-[var(--pb-lime)]" data-id="element-207" data-mp="qa3mh0bsyrli">Completely Free</span>
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-white/85" data-id="element-208" data-mp="h5os1hpjsial">
          Make smarter training decisions with three practical coaching calculators.
        </p>

        <div className="mt-5 grid gap-2 text-left" data-id="element-209" data-mp="780ivmr7388w">
          {CALCULATORS.map(calculator => <div key={calculator} className="flex items-center gap-3 rounded-xl border border-white/15 bg-[#14243a] px-4 py-3" data-id="element-210" data-mp="c6ljvoe9tvye">
              <CalculatorIcon size={18} className="shrink-0 text-[var(--pb-lime)]" aria-hidden data-id="element-211" data-mp="zyiw3glmuq01" />
              <span className="flex-1 text-sm font-700 text-white" data-id="element-212" data-mp="14xlq8602rbt8">{calculator}</span>
              <CheckCircle2Icon size={17} className="shrink-0 text-[var(--pb-lime)]" aria-label="Included" data-id="element-213" data-mp="q6cudf5kwu7n" />
            </div>)}
        </div>
      </div>
    </section>;
}